import { Component } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Task, TasksService } from '@compumark/analyst-selection-tool-client';
import { NotificationService } from '@compumark/brand-context-components';
import { LoadingSpinnerService } from 'src/app/results/services/loading-spinner.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-preview-search',
  standalone: false,
  templateUrl: './preview-search.component.html',
  styleUrls: ['./preview-search.component.scss'],
})
export class PreviewSearchComponent {
  dataSource!: MatTableDataSource<{ match: string; count: unknown }>;
  data: any;
  isLoading = false;
  task!: Task;

  constructor(
    private notificationService: NotificationService,
    private tasksService: TasksService,
    private route: ActivatedRoute,
    private loadingSpinnerService: LoadingSpinnerService,
  ) {
    const snackBarRef = this.notificationService.showSnackbar(
      'Your preview is being generated.',
      'DISMISS',
    );
    this.loadingSpinnerService.show();

    this.tasksService
      .getTask(this.route.snapshot.paramMap.get('taskId')!)
      .subscribe((task: Task) => {
        this.task = task;
      });

    this.getPreviewResponse(snackBarRef);
  }

  private getPreviewResponse(snackBarRef: MatSnackBarRef<MatSnackBar>): void {
    this.tasksService
      .getPreviewSearchResults(
        this.route.snapshot.paramMap.get('prodOrderNo')!,
        this.route.snapshot.paramMap.get('prodOrderSeqNo')!,
      )
      .subscribe({
        next: (response) => {
          this.data = response;
          this.dataSource = new MatTableDataSource(
            Object.entries(this.data?.matchReasonsCounts)
              .map(([match, count]) => ({
                match,
                count,
              }))
              .sort((a, b) => Number(b.count) - Number(a.count)),
          );
        },
        error: () => {
          this.notificationService.showSnackbar(
            'Error generating preview search: ',
            'DISMISS',
            2000,
          );
        },
        complete: () => {
          snackBarRef.dismiss();
          this.loadingSpinnerService.hide();
        },
      });
  }

  hasResultCountKey(key: string): boolean {
    return this.data?.resultCountStats
      ? Object.prototype.hasOwnProperty.call(this.data.resultCountStats, key)
      : false;
  }

  hasPreviewShowPocaCount(): boolean {
    return environment.features.previewShowPocaCount;
  }
}
